export const formatContactInfo = (data: {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}): string => {
  const { firstName, lastName, email } = data;

  let result = '';

  if (firstName) result += `${firstName} `;
  if (lastName) result += `${lastName}`;
  if ((firstName || lastName) && email) result += ', ';
  if (email) result += email;

  return result.trim();
};
